import { z } from "@/helpers/forms/zod";

const field = z.object({
  value: z.string(),
  label: z.string(),
  type: z.string(),
  id: z.number(),
});

export const openBriefFormSchema = z.object({
  productId: z.string().optional().nullable(),
  initialExpression: z.string(),
  quantity: z.string(),
  versionCount: z.string(),
  deliverableId: z.string().optional().nullable(),
  fields: z.record(z.number(), field),
});

export type OpenBriefFormType = z.infer<typeof openBriefFormSchema>;
